import NewTransaction from "../components/NewTransaction";

function New() {
  return (
    <section>
      <h3>Add New Item</h3>
      <NewTransaction />
    </section>
  );
}

export default New;
